import {z} from 'zod';

import {BaseVoidRequestSchema, BaseVoidResponseSchema} from '@dms/api/shared';

export const PostServiceCaseTypeApiResponseSchema = z
  .object({
    id: z.string().nullable().optional(),
  })
  .nullable();

export type PostServiceCaseTypeApiResponse = z.infer<typeof PostServiceCaseTypeApiResponseSchema>;

export const PostServiceCaseTypeApiArgSchema = z.object({
  body: z
    .object({
      authorizationProfileId: z.string().nullable(),
      docSeriesServiceCaseId: z.string(),
      docSeriesServiceOrderId: z.string(),
      name: z.string(),
      isDefaultServiceOrderVariant: z.boolean(),
      accountingCode: z.string().nullish(),
      defaultCheckInInspectionId: z.string().optional(),
      defaultHandoverInspectionId: z.string().optional(),
      defaultDigitalCertificateTemplateId: z.string().optional(),
    })
    .nullable(),
});

export type PostServiceCaseTypeApiArg = z.infer<typeof PostServiceCaseTypeApiArgSchema>;

export const GetServiceCaseTypeApiResponseSchema = z
  .object({
    id: z.string().nullable().optional(),
    authorizationProfileId: z.string().nullable().optional(),
    docSeriesServiceCaseId: z.string().nullable().optional(),
    docSeriesServiceOrderId: z.string().nullable().optional(),
    name: z.string().nullable().optional(),
    isDefaultServiceOrderVariant: z.boolean().nullable().optional(),
    accountingCode: z.string().nullable().optional(),
    defaultCheckInInspectionId: z.string().optional(),
    defaultHandoverInspectionId: z.string().optional(),
    defaultDigitalCertificateTemplateId: z.string().optional(),
  })
  .nullable();

export type GetServiceCaseTypeApiResponse = z.infer<typeof GetServiceCaseTypeApiResponseSchema>;

export const GetServiceCaseTypeApiArgSchema = z.object({
  serviceCaseTypeId: z.string(),
});

export type GetServiceCaseTypeApiArg = z.infer<typeof GetServiceCaseTypeApiArgSchema>;

export const PatchServiceCaseTypeApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceCaseTypeApiResponse = z.infer<typeof PatchServiceCaseTypeApiResponseSchema>;

export const PatchServiceCaseTypeApiArgSchema = z.object({
  serviceCaseTypeId: z.string(),
  body: z
    .object({
      authorizationProfileId: z.string().nullable(),
      docSeriesServiceCaseId: z.string(),
      docSeriesServiceOrderId: z.string(),
      name: z.string(),
      isDefaultServiceOrderVariant: z.boolean(),
      accountingCode: z.string().nullable().optional(),
      defaultCheckInInspectionId: z.string().optional(),
      defaultHandoverInspectionId: z.string().optional(),
      defaultDigitalCertificateTemplateId: z.string().optional(),
    })
    .nullable(),
});

export type PatchServiceCaseTypeApiArg = z.infer<typeof PatchServiceCaseTypeApiArgSchema>;

export const PatchServiceCaseTypeSetAsActiveApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceCaseTypeSetAsActiveApiResponse = z.infer<
  typeof PatchServiceCaseTypeSetAsActiveApiResponseSchema
>;

export const PatchServiceCaseTypeSetAsActiveApiArgSchema = z.object({
  serviceCaseTypeId: z.string(),
});

export type PatchServiceCaseTypeSetAsActiveApiArg = z.infer<
  typeof PatchServiceCaseTypeSetAsActiveApiArgSchema
>;

export const PatchServiceCaseTypeSetAsInactiveApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceCaseTypeSetAsInactiveApiResponse = z.infer<
  typeof PatchServiceCaseTypeSetAsInactiveApiResponseSchema
>;

export const PatchServiceCaseTypeSetAsInactiveApiArgSchema = z.object({
  serviceCaseTypeId: z.string(),
});

export type PatchServiceCaseTypeSetAsInactiveApiArg = z.infer<
  typeof PatchServiceCaseTypeSetAsInactiveApiArgSchema
>;

export const GetServiceCaseTypesApiResponseSchema = z.array(
  z.object({
    name: z.string(),
    id: z.string(),
    isActive: z.boolean(),
  })
);

export type GetServiceCaseTypesApiResponse = z.infer<typeof GetServiceCaseTypesApiResponseSchema>;

export const GetServiceCaseTypesApiArgSchema = BaseVoidRequestSchema;

export type GetServiceCaseTypesApiArg = z.infer<typeof GetServiceCaseTypesApiArgSchema>;

export const DeleteServiceCaseTypeApiResponseSchema = BaseVoidResponseSchema;

export type DeleteServiceCaseTypeApiResponse = z.infer<
  typeof DeleteServiceCaseTypeApiResponseSchema
>;

export const DeleteServiceCaseTypeApiArgSchema = z.object({
  serviceCaseTypeId: z.string(),
});

export type DeleteServiceCaseTypeApiArg = z.infer<typeof DeleteServiceCaseTypeApiArgSchema>;
